import { Trans } from "react-i18next";
import styles from "./style.module.scss";

type StrengthItemType = {
  subtitle: string;
  desc: string;
  containerStyle?: React.CSSProperties;
};
const StrengthItem: React.FC<StrengthItemType> = ({
  subtitle,
  desc,
  containerStyle,
}) => {
  return (
    <div className={`${styles.strengthItemContainer}`} style={containerStyle}>
      <div className={styles.subtitle}>{subtitle}</div>
      <div className={styles.desc}>
        <Trans i18nKey={desc} />
      </div>
    </div>
  );
};

export default StrengthItem;
